import React from 'react';
import { Link } from 'react-router-dom';

// material-ui
import { ButtonBase} from '@material-ui/core';

// project imports
import config from './../../../config';
import img from "../../../assets/images/buyume_logo.png"
//-----------------------|| MAIN LOGO ||-----------------------//

const LogoSection = () => {
    return (
        <ButtonBase disableRipple component={Link} to={config.defaultPath}>
            <img src={img} alt='logo' height={40}/>
        </ButtonBase>
    );
};

export default LogoSection;
